<template>
  <div class="h-full p-8">
    <img
      alt="logo"
      class="h-20 w-full mx-auto object-contain object-left mb-12"
      src="@/assets/logofullblack.png"
    />
    <div class="bg-bnb-mustard2 bg-opacity-10 shadow-inner rounded-lg py-4">
      <div class="font-bold uppercase text-xl py-2">New/Existing</div>
      <div class="" id="firebaseui-auth-container"></div>
    </div>
    <div id="signingInNotifier" class="flex justify-center my-6">
      <div>
        <p>Signining In...</p>
        <p class="flex justify-center">
          <img class="h-4 animate-spin my-2" src="@/assets/icons/spinner.svg" />
        </p>
        <p>{{ signInStatusText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { Storage } from "@capacitor/storage";
import { Device } from "@capacitor/device";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";
export default {
  data() {
    return {
      signingIn: false,
      signInStatusText: "Fetching app resources. Please wait",
    };
  },
  mounted() {
    document.getElementById("signingInNotifier").style.display = "none";
    Device.getInfo().then((infoObject) => {
      this.authenticate(infoObject.platform);
    });
  },
  methods: {
    authenticate(platform) {
      var termsOfService = this.$store.state.appDetails?.update?.termsOfService;
      var privacyPolicy = this.$store.state.appDetails?.update?.privacyPolicy;
      var authCredentials = {
        Anonymous: "",
        Phone: {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          defaultCountry: "NG",
          recaptchaParameters: {
            type: "image",
            size: "invisible", 
            badge: "bottomleft", 
          },
        },
        Email: {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          requireDisplayName: true,
        },
        Google: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        Facebook: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        Twitter: firebase.auth.TwitterAuthProvider.PROVIDER_ID,
        GitHub: firebase.auth.GithubAuthProvider.PROVIDER_ID,
      };
      var allowedProviders = this.$store.state.appDetails
        ?.allowedAuthProviders?.[platform] || ["Email"];
      var signInOptions = [];
      allowedProviders.forEach((provider) => {
        signInOptions.push(authCredentials[provider]);
      });
      var ui =
        firebaseui.auth.AuthUI.getInstance() ||
        new firebaseui.auth.AuthUI(firebase.auth());

      var uiConfig = {
        callbacks: {
          signInSuccessWithAuthResult: function (authResult) {
            document.getElementById("signingInNotifier").style.display =
              "block";

            Storage.get({ key: "fcmToken" }).then((tokenObject) => {
              var activeToken = tokenObject.value;
              if (!activeToken) {
                localStorage.pendingAppTokenRegistration = "true";
              }
              var user = authResult.user;
              if (authResult.additionalUserInfo.isNewUser) {
                firebase
                  .firestore()
                  .collection("Users")
                  .doc(user.uid)
                  .set({
                    uid: user.uid,
                    firstName: user.displayName?.split(" ", 2)[0] ?? "",
                    lastName: user.displayName?.split(" ", 2)[1] ?? "",
                    displayName: user.displayName ?? "",
                    email: user.email ?? "",
                    phoneNumber: user.phoneNumber ?? "",
                    address: "",
                    fcmTokens:
                      activeToken && ["ios", "android"].includes(platform)
                        ? [activeToken]
                        : [],
                  })
                  .then(() => {
                    location.replace(
                      location.protocol + "//" + location.host + "/"
                    );
                  });
              } else if (platform == "ios" || platform == "android") {
                firebase
                  .firestore()
                  .collection("Users")
                  .doc(user.uid)
                  .get()
                  .then((doc) => {
                    var fcmTokens = doc.data()?.fcmTokens || [];
                    if (activeToken && !fcmTokens.includes(activeToken)) {
                      fcmTokens.push(activeToken);
                      doc.ref.update({ fcmTokens: fcmTokens }).then(() => {
                        location.replace(
                          location.protocol + "//" + location.host + "/"
                        );
                      });
                    } else {
                      location.replace(
                        location.protocol + "//" + location.host + "/"
                      );
                    }
                  })
                  .catch(() => {
                    location.replace(
                      location.protocol + "//" + location.host + "/"
                    );
                  });
              } else {
                location.replace(
                  location.protocol + "//" + location.host + "/"
                );
              }
            });
            // return true: to allow automatic redirect;  return false: to handle redirect programatically
            return false;
          },
          uiShown: function () {},
        },
        // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
        signInFlow: "popup",
        signInOptions: signInOptions,
        tosUrl: termsOfService,
        privacyPolicyUrl: privacyPolicy,
      };
      ui.start("#firebaseui-auth-container", uiConfig);
    },
  },
};
</script>
